const isAbortedRequest = (error, signal) =>
  Boolean(
    signal?.aborted ||
      error?.name === "AbortError" ||
      error?.name === "TimeoutError" ||
      /signal is aborted|aborted without reason|operation was aborted/i.test(
        String(error?.message || ""),
      ),
  );

const createRequestTimeoutError = (error) => {
  const timeoutError = new Error(
    "Le serveur met trop de temps à répondre. Patientez un instant puis réessayez.",
  );
  timeoutError.name = "RequestTimeoutError";
  timeoutError.code = "REQUEST_TIMEOUT";
  timeoutError.retryable = true;
  timeoutError.cause = error;
  return timeoutError;
};

const isAmbiguousNetworkFailure = (error) =>
  Boolean(
    error instanceof TypeError ||
      /failed to fetch|fetch failed|networkerror|network request failed|load failed|connection.*(reset|closed|lost)/i.test(
        String(error?.message || ""),
      ),
  );

const createAmbiguousNetworkError = (error) => {
  const networkError = new Error(
    "La réponse du serveur s’est perdue. MOO Sync vérifie la commande avant toute nouvelle tentative.",
  );
  networkError.name = "AmbiguousNetworkError";
  networkError.code = "REQUEST_NETWORK_UNKNOWN";
  networkError.retryable = true;
  networkError.cause = error;
  return networkError;
};

const normalizeNetworkRequestError = (error, signal) =>
  isAbortedRequest(error, signal)
    ? createRequestTimeoutError(error)
    : isAmbiguousNetworkFailure(error)
      ? createAmbiguousNetworkError(error)
      : error;

const getSafeNetworkErrorMessage = (
  errorOrMessage,
  fallback = "Une erreur est survenue. Veuillez réessayer.",
) => {
  const error =
    typeof errorOrMessage === "string"
      ? new Error(errorOrMessage)
      : errorOrMessage;
  if (isAbortedRequest(error)) return createRequestTimeoutError(error).message;
  return String(error?.message || errorOrMessage || fallback);
};

module.exports = {
  createRequestTimeoutError,
  createAmbiguousNetworkError,
  getSafeNetworkErrorMessage,
  isAmbiguousNetworkFailure,
  isAbortedRequest,
  normalizeNetworkRequestError,
};
